import React from "react";

import CONFIG from '../../config';

import axios from "axios";
// import dayjs from 'dayjs';

import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import HomeIcon from '@mui/icons-material/Home';
import NavbarLeftItem from "./NavbarLeftItem";
import PersonIcon from '@mui/icons-material/Person';
import { Button } from "@mui/material";
import WidgetAlertbox from "../widgets/WidgetAlertbox";


function NavbarLeftClient({ current }) {
  const dayjs = require('dayjs');
  const duration = require('dayjs/plugin/duration');
  dayjs.extend(duration);

  const [clicked, setClicked] = React.useState(!(current.date_suppression === null));
  var { days, hours, minutes } = ["", "", ""];
  
  if (clicked) {
    const duration = dayjs.duration(dayjs(current.date_suppression).diff(dayjs()));
    days = duration.days();
    hours = duration.hours();
    minutes = duration.minutes();
  }

  const [alertDelete, openAlertDelete] = WidgetAlertbox("Êtes-vous sûr(e) de vouloir supprimer votre compte ? Cette action prendra effet dans un délai de 30 jours.");

  return (
    <>
    {alertDelete}
      <div className="fixed z-49 w-36 min-h-full bg-ame-gray justify-between items-end flex flex-col">
        <div className="divide-y divide-gray-600 flex flex-col items-center justify-between bg-ame-gray text-white w-full min-h-full">
          <div className="w-full"></div>
          <NavbarLeftItem
            icon={
              <HomeIcon sx={{ fontSize: 40 }}></HomeIcon>
            }
            text={"Mon Dossier"}
            href={CONFIG.BASE_URL + "/client/dossier"}
          />
          <NavbarLeftItem
            icon={
              <PersonIcon sx={{ fontSize: 40 }}></PersonIcon>
            }
            text={"Mes Infos"}
            href={CONFIG.BASE_URL + "/client/questionnaire"}
          />
        </div>
        <div className="w-full h-52 text-center px-2">
          <Button variant="contained" color={clicked ? "info" : "error"} disabled={!(['incomplet', 'complet', 'verifie', 'propose'].includes(current.dossier.etat))}
            onClick={() => openAlertDelete(() => {
              axios.post(CONFIG.API_URL + '/api/client_delete_date/' + current._id, {}, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then((response) => {
                  switch (response.status) {
                    case 200:
                      setClicked(x => !x);
                      break;

                    default:
                      break;
                  }
                })
                .catch((e) => {

                });
            }, !clicked)}
          >
            {!clicked ? "Supprimer mon compte" : `Annuler la suppression (J-${days})`}
          </Button>
        </div>
      </div>
    </>
  );
}

export default NavbarLeftClient;